import React, { memo, useState, Fragment } from "react";
import { useRecoilValue  } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';
import { optionPriceConvertDisplay } from '../../../services/optionPriceConvert';

import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';

export const OptionCheckbox = memo((props) => {
  const { item, onChangeOption } = props;
  const isConfirm = useRecoilValue(confirmState);
  const orderData = useRecoilValue(orderState);

  return (
    <>
      <div className="list-group-item">
        <input className="form-check-input me-1" type="checkbox" name="selectOptions" value={item.option_id} id={`option${item.option_id}`} onChange={onChangeOption} disabled={isConfirm} defaultChecked={orderData.options.find((v) => v.option_id === item.option_id)} />
        <label className="form-check-label" htmlFor={`option${item.option_id}`}>
          {item.option_name}
          { optionPriceConvertDisplay(item.option_price) }
        </label>
        <PopoverText textTitle={item.option_name} textBody={item.option_description} />
      </div>
    </>
  );
});